function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
  fill: "#233447"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M38.7267 11.6913L27.0635 20.2473L29.232 15.2051L38.7267 11.6913Z",
  fill: "#E17726",
  stroke: "#E17726",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.8242 11.6913L23.3837 20.3274L21.319 15.2051L11.8242 11.6913ZM34.5285 31.5308L31.4247 36.2305L38.07 38.0443L39.973 31.633L34.5285 31.5308ZM10.5898 31.633L12.4813 38.0443L19.1149 36.2305L16.0237 31.53L10.5898 31.633Z",
  fill: "#E27625",
  stroke: "#E27625",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.756 23.59L16.9116 26.3502L23.4875 26.6467L23.2681 19.6299L18.756 23.59ZM31.7922 23.59L27.2127 19.5515L27.0627 26.6477L33.6385 26.351L31.7922 23.59ZM19.1139 36.2302L23.0941 34.325L19.6681 31.6785L19.1139 36.2302ZM27.4552 34.325L31.4237 36.2302L30.882 31.6785L27.4552 34.325Z",
  fill: "#E27625",
  stroke: "#E27625",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M31.4247 36.2305L27.4552 34.3253L27.7792 36.8813L27.7437 37.964L31.4247 36.2305ZM19.1147 36.2305L22.8063 37.965L22.7832 36.8813L23.0949 34.3253L19.1147 36.2305Z",
  fill: "#D5BFB2",
  stroke: "#D5BFB2",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.8747 29.9902L19.5757 29.0322L21.9059 27.9713L22.8747 29.9902ZM27.6745 29.9902L28.6425 27.9713L30.985 29.0322L27.6745 29.9902Z",
  fill: "#233447",
  stroke: "#233447",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.1147 36.2305L19.6919 31.531L16.0234 31.633L19.1147 36.2305ZM30.859 31.531L31.4245 36.2305L34.5272 31.633L30.859 31.531ZM33.6402 26.3505L27.0635 26.648L27.6752 29.9903L28.6432 27.9713L30.9857 29.0323L33.6402 26.3505ZM19.5764 29.0323L21.9066 27.9713L22.8755 29.9903L23.4873 26.648L16.9115 26.3513L19.5764 29.0323Z",
  fill: "#CC6228",
  stroke: "#CC6228",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.9116 26.3505L19.6689 31.6788L19.5766 29.0323L16.9116 26.3505ZM30.986 29.0323L30.8822 31.6788L33.6395 26.3513L30.986 29.0323ZM23.4875 26.648L22.8756 29.9903L23.6482 33.938L23.8223 28.7348L23.4875 26.648ZM27.0635 26.648L26.7402 28.724L26.902 33.938L27.6745 29.9903L27.0635 26.648Z",
  fill: "#E27525",
  stroke: "#E27525",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.6745 29.9905L26.902 33.9382L27.4553 34.3255L30.8813 31.679L30.985 29.0325L27.6745 29.9905ZM19.5757 29.0325L19.6681 31.679L23.0941 34.3255L23.6482 33.9382L22.8756 29.9905L19.5757 29.0325Z",
  fill: "#F5841F",
  stroke: "#F5841F",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.7437 37.965L27.7792 36.881L27.479 36.6302H23.0718L22.7832 36.881L22.8063 37.964L19.1147 36.2305L20.4068 37.28L23.0265 39.0715H27.5137L30.144 37.28L31.4247 36.2305L27.7437 37.965Z",
  fill: "#C0AC9D",
  stroke: "#C0AC9D",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.4557 34.325L26.9015 33.9375H23.6496L23.0955 34.325L22.7847 36.8807L23.0724 36.6297H27.4797L27.7797 36.8807L27.4557 34.325Z",
  fill: "#161616",
  stroke: "#161616",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.2232 20.8063L40.2027 16.0846L38.7267 11.6913L27.456 19.962L31.794 23.5894L37.9197 25.359L39.2695 23.7954L38.6807 23.3728L39.6157 22.5293L38.9 21.9817L39.8342 21.2739L39.2232 20.8063ZM10.3472 16.0837L11.3391 20.8063L10.705 21.2747L11.6508 21.9817L10.9359 22.5293L11.8701 23.3737L11.2814 23.7963L12.6312 25.3583L18.7577 23.5903L23.0948 19.9629L11.824 11.6913L10.3472 16.0837Z",
  fill: "#763E1A",
  stroke: "#763E1A",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M37.9193 25.3585L31.7938 23.5905L33.639 26.3515L30.8818 31.679L34.528 31.6332H39.9725L37.9193 25.3585ZM18.7565 23.5905L12.6309 25.3585L10.5884 31.6332H16.0231L19.6685 31.679L16.9112 26.3515L18.7565 23.5905ZM27.0633 26.6482L27.4558 19.9623L29.2318 15.2053H21.3185L23.0945 19.9623L23.487 26.6482L23.6371 28.7472L23.6487 33.9382H26.9015L26.913 28.7472L27.0633 26.6482Z",
  fill: "#F5841F",
  stroke: "#F5841F",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgSourceMetamask = function SvgSourceMetamask(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSourceMetamask, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source_metamask.ac97f3ab.svg";
export { ForwardRef as ReactComponent };